<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="게시글 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="작성자">
                  <lp-adm-drop-input ref="adminput_post"
                                     :data.sync="userlist"
                                     :selectVal="value.display_name"
                                     @onSelect="res=>selectAuthor(res, 'post')"
                                     added_field="type"
                                     :placeholder="value.display_name"
                                     width="250px"
                                     listAlign="left"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시글 노출기간">
                  <div class="flex">
                    <admin-date-picker
                      :data="value.start_date"
                      @setDate="selDateMin"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                      :data="value.end_date"
                      @setDate="selDateMax"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시물 노출 여부">
                  <lp-radio :val="value.enable_post"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                            @onSelect="onSelectedPostState"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-3">
                <admin-form-item label="노출 우선순위">
                  <input class="input"
                         :value="value.priority"
                         @input="e => value.priority = e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="제목*">
                  <input class="input"
                         :value="value.title"
                         @input="e => value.title = e.target.value"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내용*">
                  <lp-editor :text.sync="value.content"></lp-editor>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="동영상 링크">
                  <input class="input"
                         placeholder="Youtube, Vimeo 링크 및 mp4 링크 삽입"
                         :value="value.video"
                         @input="e => value.video = e.target.value"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="activate_classification">
                <admin-form-item label="게시물 구분 값 선택">
                  <div v-for="(field,idx) in fieldlist" :key="'field-'+idx">
                    <lp-check-bool :checked-val.sync="field.value" :label="field.label"></lp-check-bool>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="$store.getters.mode==='admin'">
                <admin-form-item label="게시물 평가점수"
                                 desc="게시물 노출 우선순위에 반영됩니다."
                                 tip="필터정렬 > 정렬 설정 메뉴에서 게시물 정렬 > 인기순 설정 > 인기순 설정의 퍼센트에 합산되어 우선순위에 반영됩니다.">
                  <input class="input"
                         style="width:100px"
                         :value="value.score"
                         @input="e => value.score = e.target.value"
                         type="number">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시글 대표 이미지" :desc="getRatio('post_card')">
                  <input-img :url.sync="value.img"></input-img>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="맞춤 DB">
            <div class="columns is-multiline">
              <div class="column is-full"
                   v-for="(param, index) in post_param"
                   v-bind:key="'param_input'+index" v-if="post_param.length > 0">
                <admin-form-item :label="param.name">
                  <input-param :param.sync="param"></input-param>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="$route.query.id && board && board.activate_comment">
          <admin-box-item title="댓글 등록">
            <!-- 댓글 목록 -->
            <div>
              <div class="comment-sub-title">
                댓글 목록 ({{ commentsArr.length }})
                <i v-if="isComment===false" @click="isComment=true" class="material-icons" style="cursor: pointer;">keyboard_arrow_down</i>
                <i v-if="isComment===true" @click="isComment=false" class="material-icons" style="cursor: pointer;">keyboard_arrow_up</i>
              </div>
              <div style="padding:12px">
                <div
                  v-if="isComment===true"
                  v-for="(item, idx) in commentsArr" :key="'comments'+idx"
                  style="margin-top: 12px;">
                  <div
                    v-if="idx!==0"
                    style="margin: 15px 0; width: 100%; height: 1px; background: #ddd;"></div>
                  <div style="display:flex; font-size: .9rem; color: #555;">
                    <div style="width: 82%;">
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성자</div>
                        <div>{{ item.display_name }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성일</div>
                        <div>{{ item.created_time }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성내용</div>
                        <div>{{ item.content }}</div>
                      </div>
                    </div>
                    <div class="buttons" v-if="!item.is_deleted">
                      <button @click="clickUpdate(item)" class="button" style="padding: 6px 10px;">수정</button>
                      <button @click="clickDelete(item)" class="button is-danger" style="padding: 6px 10px;">삭제</button>
                    </div>
                    <div v-else>삭제된 댓글입니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 댓글 작성 -->
            <div>
              <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
              <admin-form-item label="작성자" style="margin-bottom:20px">
                <lp-adm-drop-input ref="adminput_comment"
                                   :data.sync="userlist"
                                   :selectVal="comment_username"
                                   @onSelect="res=>selectAuthor(res, 'comment')"
                                   added_field="type"
                                   :placeholder="comment_username"
                                   width="250px"
                                   listAlign="left"
                                   style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
              </admin-form-item>
              <admin-form-item label="작성 내용">
                <div class="flex">
                  <div style="margin-right:12px;width:90%">
                    <textarea class="textarea" v-model="comments.content"></textarea>
                  </div>
                  <div>
                    <button class="button is-primary"
                            style="height: 100% !important;"
                            @click="clickCommentsReg">등록</button>
                  </div>
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="$route.query.id && board.activate_reply">
          <admin-box-item title="답변 등록">
            <!--<lp-check-bool :checked-val.sync="value.reply_is_secret"
                           label="비밀글 여부"></lp-check-bool>-->
            <admin-form-item label="작성자" style="margin-bottom:20px">
<!--              :selectVal="comment_username"-->
<!--              :placeholder="comment_username"-->
              <lp-adm-drop-input ref="adminput_comment"
                                 :data.sync="userlist"
                                 :selectVal="value.reply_display_name"
                                 :placeholder="value.reply_display_name"
                                 @onSelect="res=>selectAuthor(res, 'comment')"
                                 added_field="type"
                                 width="250px"
                                 listAlign="left"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
            </admin-form-item>
            <admin-form-item label="작성 내용">
              <div class="flex">
                <div style="margin-right:12px;width:90%">
                  <textarea class="textarea" v-model="value.reply_content"></textarea>
                </div>
                <div>
                  <button class="button is-primary"
                          style="height: 100% !important;"
                          @click="clickReplyReg">등록</button>
                </div>
              </div>
            </admin-form-item>
          </admin-box-item>
        </div>

      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

  </div>
</template>

<script>
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import AdminDatePicker from "../../module/admin/AdminDatePicker";
  import InputImg from "../../module/common/InputImg";
  import LpRadio from "../../module/common/LpRadio";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import InputParam from "../../module/custom/InputParam";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpCheck from "../../module/common/LpCheck";

export default {
  layout: "Main",
  components: {
    LpCheck,
    LpCheckBool,
    InputParam,
    LpAdmDropInput,
    LpRadio,
    AdminDatePicker,
    AdminFormItem,
    AdminBoxItem,
    InputImg,
  },
  created() {
    // 새로 등록
    if ( this.$route.query.id === undefined ) {
      /*this.event.start_date = this.resetNewDate('start');
      this.event.end_date = this.resetNewDate('end');
      this.event.username = this.$store.getters.admin.username;*/
      this.getFields();
      this.getUserList();
      this.paramAllList();
    }
    // 라우팅
    else {
      this.getFields();
      this.getUserList();
      this.getData();
      this.getComment();
      this.value.start_date = this.convertNewDate(this.value.start_date);
      this.value.end_date = this.convertNewDate(this.value.end_date);
    }
  },
  data() {
    return {
      board: undefined,
      // 맞춤 DB
      param_list:[],
      post_param: [],
      value: {
        id: 0,
        enable_post: true,
        start_date: '',
        end_date: '',
        // date: {
        //   min: "2017-01-01",
        //   max: "2099-12-31"
        // },
        priority: 99,
        title: "",
        content: "",
        video: "",
        img: "",
        fields: [],
        reply_content: '',
        reply_is_secret: '',
        reply_author: ''
      },
      activate_classification: false,
      isComment: false, // 댓글 목록 fold/unfold
      // 댓글 목록
      commentsArr: [],
      // 댓글 작성
      comments: {
        id: "", // 상품문의상세 게시글 id
        content: "",
        /*writer: "",
        writer_type: "",
        writer_name: "",
        writer_username: "",
        date: "",
        lock: false // 비밀댓글 여부*/
      },
      // 작성자 전체 목록 리스트
      userlist: [],
      post_username: '',
      post_user_id: '',
      post_user_type: '',
      comment_username: '',
      comment_user_id: '',
      comment_user_type: '',
      fieldlist: [] // 게시판 구분값 설정한 데이터 리스트
    };
  },
  methods: {
    selFields(res){
      console.log(res)
    },
    // 게시판에서 설정한 필드를 가져옴
    getFields(){
      this.$axios.get(this.getUrl(`board/${this.$route.params.id}`)).then(res=>{
        if(res.status===200){
          this.board = res.data;
          let fields = res.data.fields;
          let fields_arr = [];
          for(let i=0; i<fields.length; i++){
            fields_arr.push({label: fields[i], value:false });
          }
          this.fieldlist = fields_arr;
          this.activate_classification = res.data.activate_classification;
        }
      })
    },
    paramAllList(){
      // 파라미터 리스트
      this.$axios.get('admin/board/post/param').then(res=>{
        if(res.status===200){
          this.param_list = res.data;
          let result = this.paramChecker(this.param_list, this.post_param);
          if(result.length > 0) this.post_param = this.post_param.concat(result);
        }
      })
    },
    // 유저 선택
    selectAuthor(res, type) {
      if (type==='post') {
        this.post_user_id = res.value;
        this.post_user_type = res.type;
      }
      else if (type==='comment') {
        this.comment_user_id = res.value;
        this.comment_user_type = res.type;
      }
    },
    getUserList(){
      this.$axios.get('public/user/whole').then(res=>{
        this.userlist = res.data;

      })
    },
    getUsername(type){
      if (type==='post') {
        if(this.userlist.length>0){
          for(let i=0; i<this.userlist.length; i++){
            if(this.userlist[i].value===this.post_user_id &&
              this.post_user_type===this.userlist[i].type){
              this.post_username = this.userlist[i].name;
              break;
            }
          }
        }
      }
      else if (type==='comment') {
        if(this.userlist.length>0){
          for(let i=0; i<this.userlist.length; i++){
            if(this.userlist[i].value===this.comment_user_id &&
              this.comment_user_type===this.userlist[i].type){
              this.comment_username = this.userlist[i].name;
              break;
            }
          }
        }
      }

    },
    // 게시판 노출 여부
    onSelectedPostState(val) {
      this.value.enable_post = val;
    },
    getData() {
      if (this.$route.query.id) {
        let url = 'board/' + this.$route.params.id + '/post/' + this.$route.query.id;
        this.$axios.get(this.getUrl(url))
          .then(res => {
            this.value = res.data.post;
            this.post_param = res.data.params;
            if (res.data.post.user_type === 'admin') {
              this.post_user_type = 'admin';
              this.post_user_id = res.data.post.admin;
            }
            else if (res.data.post.user_type === 'partner') {
              this.post_user_type = 'partner';
              this.post_user_id = res.data.post.partner;
            }
            this.getUsername('post');
            this.paramAllList();

            this.fieldlist.forEach(item=>{
              console.log(this.value.fields.includes(item.label))
              if(this.value.fields.includes(item.label)){
                item.value=true;
              }
            })
          });
      }
      else this.paramAllList();
    },
    getComment() {
      let url = 'board/' + this.$route.params.id + '/post/' + this.$route.query.id + '/comment';
      this.$axios.get(this.getUrl(url))
        .then(res=>{
          this.commentsArr = res.data.data;
          if(res.data.user_type==='admin'){
            this.comment_user_type = 'admin';
            this.comment_user_id = res.data.admin;
          }
          else if(res.data.user_type==='partner'){
            this.post_user_type = 'partner';
            this.comment_user_id = res.data.partner;
          }
          this.getUsername('comment');
        })
    },
    // 삭제
    clickDelete(item) {
      let url = 'board/' + this.$route.params.id +
        '/post/' + this.$route.query.id + '/comment/' + item.id;
      this.$axios.delete(this.getUrl(url))
        .then(res=>{
          if(res.status===200){
            this.toast('삭제되었습니다.');
            this.getComment();

            this.comments = {
              id: "",
              content: ""
            }
          }
        })

    },
    // 수정
    clickUpdate(item) {
      //console.log(item)
      this.comments.id = item.id;
      this.comments.content = item.content;
      this.$refs.adminput_comment.selectedLabel = item.display_name;
    },
    // 답변 등록
    clickReplyReg() {
      let url = 'board/' + this.$route.params.id + '/post/' + this.$route.query.id + '/reply';
      this.$axios.post(this.getUrl(url), {
        content: this.value.reply_content,
        user_id: this.comment_user_id,
        user_type: this.comment_user_type
      }).then(res=>{
        if(res.status===200) {
          // this.comment_user_id = '';
          // this.comment_user_type = '';
          // this.comment_username = '';
          // this.$refs.adminput_comment.selectedLabel = '';
          this.getData();
          this.toast('답변이 등록되었습니다.')
        }
      })
    },
    // 댓글 등록
    clickCommentsReg() {
      if(!this.comments.id){
        let url = 'board/' + this.$route.params.id + '/post/' + this.$route.query.id + '/comment';
        this.$axios.post(this.getUrl(url), {
          content: this.comments.content,
          user_id: this.comment_user_id,
          user_type: this.comment_user_type
        }).then(res=>{
          if(res.status===200){
            this.getComment();
            this.comments = {
              id: '',
              content: ''
            }
            if(!this.isComment){
              this.isComment = true;
            }
          }
        })

        this.comment_user_id = '';
        this.comment_user_type = '';
        this.comment_username = '';
        this.$refs.adminput_comment.selectedLabel = '';
      }
      else{
        let url = 'board/' + this.$route.params.id +
          '/post/' + this.$route.query.id + '/comment/' + this.comments.id;
        this.$axios.patch(this.getUrl(url), {
          content: this.comments.content,
          user_id: this.comment_user_id,
          user_type: this.comment_user_type
        }).then(res=>{
          if(res.status===200){
            this.getComment();
            this.comments = {
              id: '',
              content: ''
            }
          }
        })

        this.comment_user_id = '';
        this.comment_user_type = '';
        this.comment_username = '';
      }
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    // 댓글 작성자 선택
    selectCommentsWriter(item) {
      this.comments.writer = item.name + `(${item.username})`;
      this.comments.writer_type = item.type;
      this.comments.writer_name = item.name;
      this.comments.writer_username = item.username;
    },
    selDateMin(val) {
      this.value.start_date = val;
    },
    selDateMax(val) {
      this.value.end_date = val;
    },
    priorityKeyUp(value) {
      this.value.priority = value;
    },
    done() {
      let err = '';
      if ( !this.value.title ) err = '제목을 입력하세요.';
      else if( !this.value.content ) err= '내용을 입력하세요.';

      if ( err ) {
        this.toast(err);
        return;
      }

      if(!this.$route.query.id){
        let url = 'board/' + this.$route.params.id + '/post';
        let value = this.value;
        value.params = this.post_param;
        value.user_type = this.post_user_type;
        value.user_id = this.post_user_id;
        if(!this.value.start_date){
          value.start_date = '1111-01-01';
        }
        if(!this.value.end_date){
          value.end_date = '9999-01-01';
        }

        this.checkedField();
        this.$axios.post(this.getUrl(url), this.value).then(res=>{
          if(res.status===200){
            this.toast('등록되었습니다.');
            this.$router.replace(this.getPath('board/' + this.$route.params.id + '/post?title='+this.$route.query.title));
          }
        })
      }
      else {
        let url = 'board/' + this.$route.params.id + '/post/' + this.$route.query.id;
        let value = this.value;
        value.params = this.post_param;
        value.user_type = this.post_user_type;
        value.user_id = this.post_user_id;
        if(!this.value.start_date){
          value.start_date = '1999-01-01';
        }
        if(!this.value.end_date){
          value.end_date = '9999-01-01';
        }

        this.checkedField();
        this.$axios.patch(this.getUrl(url), this.value).then(res=>{
          if(res.status===200){
            this.toast('등록되었습니다.');
            this.$router.replace(this.getPath('board/' + this.$route.params.id + '/post?title='+this.$route.query.title));
          }
        })
      }
    },
    checkedField(){
      let selectedField = [];
      for(let i=0; i<this.fieldlist.length; i++){
        if(this.fieldlist[i].value){
          selectedField.push(this.fieldlist[i].label);
        }
      }
      this.value.fields = selectedField;
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }

  .event-comment-content {
    padding: 20px;
    font-size: 0.95rem;
    color: #222;
    border-radius: 3px;
    border: none;
    background-color: #f2f7f8;
    display: block;
    width: 100%;
    height: 120px;
  }

  .btn-add-img {
    margin: 0 8px 8px 0;
    background: #f2f7f8;
    width: 80px;
    height: 80px;
    text-align: center;
  }

  .btn-add-img i {
    font-size: 3rem;
    line-height: 80px;
    color: #555;
  }
</style>
